import { BaseActionSheet } from '@/components/base-action-sheet';
import { List } from '@/components/list';
import { OrderInvoiceActionListOption } from '@/components/orders/order-invoice-actions';
import { StyleSheet } from 'react-native';

interface Props {
  actions: OrderInvoiceActionListOption[];
  onClose: () => void;
}

export const OrderInvoiceActionsSheet: React.FC<Props> = ({
  actions,
  onClose,
}) => (
  <BaseActionSheet
    contentStyle={styles.actionsContentStyle}
    isVisible
    onClose={onClose}
  >
    <List<OrderInvoiceActionListOption>
      data={actions}
      onSelect={async (item) => {
        if (item.metadata?.stackedSheet) {
          onClose();
          await item.metadata?.onPress();
        } else {
          await item.metadata?.onPress();
          onClose();
        }
      }}
      renderLeftComponent={(item) => {
        const { Icon, iconProps } = item.metadata!;
        return <Icon height={24} width={24} {...iconProps} />;
      }}
    />
  </BaseActionSheet>
);

const styles = StyleSheet.create({
  actionsContentStyle: {
    paddingHorizontal: 0,
    paddingTop: 24,
  },
});
